import React from 'react';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import Spinner from '@atlaskit/spinner';
import Attach from 'modules/addon/ChooseParent';
import Search from 'modules/addon/Search';
import { Props } from 'modules/addon/VisualAddonPage';
import PageBanners from 'modules/addon/PageBanners';
import MultiAddonInfo from 'modules/addon/MultiAddonInfo';
import * as addon from 'modules/addon';
import { Dimensions, Font } from 'components/visuals';

const OuterWrapper = styled.div`
  width: ${Dimensions.units(95)}px;
`;

const Wrapper = styled.div`
  border: 1px solid ${token('color.icon.subtle', '#626F86')};
  border-radius: 4px;
  font-family: ${Font.family};
  flex-grow: 1;
`;

const Entry = styled.div`
  border-top: 1px solid ${token('color.icon.subtle', '#626F86')};
  &:first-child {
    border-top: none;
  }
`;

type WithExpanded = { expanded: boolean };

const Header = styled.div<WithExpanded>`
  background-color: ${(props) =>
    props.expanded
      ? token('color.background.input', '#FFFFFF')
      : token('color.background.neutral', '#F1F2F4')};
  padding: 0 14px;
  line-height: 48px;
  cursor: pointer;
  position: relative;
  border-radius: 4px;
  &:hover {
    background-color: ${token('color.background.input', '#FFFFFF')};
  }
`;
const Title = styled.span`
  font-family: ${Font.displayFamily};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 1px;
  color: ${token('color.text', '#172B4D')};
`;

const Line = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: ${token('color.text', '#172B4D')};
`;

const Body = styled.div`
  padding: ${Dimensions.units(2)}px 0;
  border-top: 1px solid ${token('color.icon.subtle', '#626F86')};
  margin: 0 ${Dimensions.units(2)}px;
`;

const LoadingWrapper = styled.div`
  text-align: center;
`;

const Chevron = () => (
  <span style={{ position: 'absolute', right: '16px', top: '6px' }}>
    <ChevronDownIcon label="open" />
  </span>
);

const Loader = () => (
  <LoadingWrapper>
    <Spinner interactionName="accordion-spinner" size="medium" />
  </LoadingWrapper>
);

const Accordion = (props: Props) => {
  return (
    <OuterWrapper data-testid="addons.accordion.container">
      <PageBanners {...props} />
      <MultiAddonInfo {...props} />
      <Wrapper>
        <Entry>
          <Header
            expanded={props.mode === addon.model.SEARCH}
            onClick={props.events.onModeChange(addon.model.SEARCH)}
          >
            <Title>search</Title>
            <Line> - Look up a license by SEN</Line>
            {props.mode !== addon.model.SEARCH && <Chevron />}
          </Header>
          {props.mode === addon.model.SEARCH && (
            <Body>
              <Search {...props} />
            </Body>
          )}
        </Entry>
        <Entry>
          <Header
            expanded={props.mode === addon.model.CHOOSE}
            onClick={props.events.onModeChange(addon.model.CHOOSE)}
          >
            <Title>choose</Title>
            <Line> - Choose a license to attach to</Line>
            {props.mode !== addon.model.CHOOSE && <Chevron />}
          </Header>
          {props.mode === addon.model.CHOOSE && (
            <Body>
              {props.overviewProgress.fold({
                loading: () => <Loader />,
                success: (overviewData) => (
                  <Attach {...props} data={{ ...props.data, ...overviewData }} />
                ),
              })}
            </Body>
          )}
        </Entry>
      </Wrapper>
    </OuterWrapper>
  );
};

export default Accordion;
